import React, { FC } from 'react';
import {
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
  useFormContext,
  useWatch
} from 'react-hook-form';

import AttachmentForm from 'buyside/components/presentation/IdeaForm/WriteupAndAttachments/Attachments/AttachmentForm/attachmentForm';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Icon from 'buyside/components/presentation/Icon/icon';
import Link from 'buyside/components/presentation/Link/link';

import { IdeaFormInput } from 'buyside/util/researchSubmission';
import { getExtensionIcon, getFilepathExtension } from 'buyside/util/fileHelper';

import styles from './attachmentsStyles.scss';

const AttachmentPreview: FC<{
  index: number;
  remove: UseFieldArrayRemove;
  update: UseFieldArrayUpdate<IdeaFormInput, 'attachments'>;
}> = ({ index, remove, update }) => {
  const {
    control,
    formState: { isSubmitting }
  } = useFormContext<IdeaFormInput>();

  const attachment = useWatch({ control, name: `attachments.${index}` });

  const { attachmentType, filename, fromUpdate, researchType, url } = attachment;

  return (
    <div className={styles.attachmentPreview}>
      <div className={styles.attachmentPreviewInfo}>
        {attachmentType ? (
          <p>
            <strong>{attachmentType}</strong>
          </p>
        ) : null}
        <Link className={styles.attachmentPreviewLink} to={url} target="_blank">
          <Icon type={getExtensionIcon(getFilepathExtension(filename))} />
          {filename}
        </Link>
        {fromUpdate ? <label>From Idea Update</label> : null}
      </div>
      {fromUpdate ? null : (
        <div className={styles.attachmentPreviewActions}>
          <AttachmentForm
            attachment={attachment}
            onSubmitCallback={values => update(index, values)}
            researchType={researchType}
          />
          <Button
            disabled={isSubmitting}
            onClick={() => remove(index)}
            size={BUTTON_SIZES.SMALL}
            text="Delete"
            type={BUTTON_TYPES.LINK}
          />
        </div>
      )}
    </div>
  );
};

export default AttachmentPreview;
